export default __webpack_public_path__ + "static/media/extingaImg_1.1237ce11.webp";